import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import { ellipsis } from '../../../../constants/helperCssRules';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: 'calc(100% - 6px)',
    lineHeight: '22px',
  },
  valueName: {
    ...ellipsis(),
  },
  highlightedValue: {
    fontFamily: 'Proximanova-Bold',
  },
  inputDisabled: {
    color: primary.bluish5,
  },
}));

const MultiValue = ({ index, getValue, selectProps, innerProps }) => {
  const classes = useStyles();

  if (index > 0) {
    return null;
  }

  const { isValueHighlighted, isDisabled } = selectProps;
  const labels = getValue()
    .map(option => option.label)
    .join(', ');

  return (
    <Typography
      className={classNames(classes.root, {
        [classes.highlightedValue]: isValueHighlighted,
        [classes.inputDisabled]: isDisabled,
      })}
      component="div"
      {...innerProps}
    >
      <span className={classes.valueName}>{labels}</span>
    </Typography>
  );
};

export default MultiValue;
